export const SERVER_URL = process.env.REACT_APP_API_SERVER_URL;
